import { createSession } from '../../../../lib/api'

// Create a closed session for this user
export const createViewableSession = async (userID: string) => {
  // @ts-ignore
  const session: SessionUpdate = {
    name: null,
    topic: null,
    state: 'ENDED',
    profile: 'PUBLIC_CLOSED',
    owner_id: userID,
    // TODO: Remove this later
    inbox_id: '00000000-0000-4b00-8157-000000000001',
    assigned_to: null,
    tags: [],
    userIds: [userID],
    closedAt: new Date().toISOString()
  }

  const sessionObj = await createSession(session)

  return sessionObj.id
}
